import {
  getDepositsData,
  downloadDepositData,
  editDepositRegisterData,
  getDepositCurrentMonthGroupData,
  getDepositByMonthGroupData,
  getDepositDetailCurrentMonthGroupData,
  getDepositDetailByMonthGroupData,
  downloadDepositDetailCurrentMonthData,
  downloadDepositDetailByMonthData,
  sendMailDepositDetailMonthData,
  sendMailDepositDetailByShopMonthData
} from '../libs/apis/DepositApi';

export const GET_DEPOSITS_REQUEST = 'GET_DEPOSITS_REQUEST';
export const GET_DEPOSITS_SUCCESS = 'GET_DEPOSITS_SUCCESS';
export const GET_DEPOSITS_FAILURE = 'GET_DEPOSITS_FAILURE';

export const DOWNLOAD_DEPOSIT_REQUEST = 'DOWNLOAD_DEPOSIT_REQUEST';
export const DOWNLOAD_DEPOSIT_SUCCESS = 'DOWNLOAD_DEPOSIT_SUCCESS';
export const DOWNLOAD_DEPOSIT_FAILURE = 'DOWNLOAD_DEPOSIT_FAILURE';

export const EDIT_DEPOSIT_REGISTER_REQUEST = 'EDIT_DEPOSIT_REGISTER_REQUEST';
export const EDIT_DEPOSIT_REGISTER_SUCCESS = 'EDIT_DEPOSIT_REGISTER_SUCCESS';
export const EDIT_DEPOSIT_REGISTER_FAILURE = 'EDIT_DEPOSIT_REGISTER_FAILURE';

export const GET_DEPOSIT_CURRENT_MONTH_GROUP_REQUEST =
  'GET_DEPOSIT_CURRENT_MONTH_GROUP_REQUEST';
export const GET_DEPOSIT_CURRENT_MONTH_GROUP_SUCCESS =
  'GET_DEPOSIT_CURRENT_MONTH_GROUP_SUCCESS';
export const GET_DEPOSIT_CURRENT_MONTH_GROUP_FAILURE =
  'GET_DEPOSIT_CURRENT_MONTH_GROUP_FAILURE';

export const GET_DEPOSIT_BY_MONTH_GROUP_REQUEST =
  'GET_DEPOSIT_BY_MONTH_GROUP_REQUEST';
export const GET_DEPOSIT_BY_MONTH_GROUP_SUCCESS =
  'GET_DEPOSIT_BY_MONTH_GROUP_SUCCESS';
export const GET_DEPOSIT_BY_MONTH_GROUP_FAILURE =
  'GET_DEPOSIT_BY_MONTH_GROUP_FAILURE';

export const GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST =
  'GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST';
export const GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS =
  'GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS';
export const GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE =
  'GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE';

export const GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST =
  'GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST';
export const GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS =
  'GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS';
export const GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE =
  'GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE';

export const DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST =
  'DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST';
export const DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS =
  'DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS';
export const DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE =
  'DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE';

export const DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST =
  'DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST';
export const DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS =
  'DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS';
export const DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE =
  'DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE';

export const SEND_MAIL_DEPOSIT_DETAIL_MONTH_REQUEST =
  'SEND_MAIL_DEPOSIT_DETAIL_MONTH_REQUEST';
export const SEND_MAIL_DEPOSIT_DETAIL_MONTH_SUCCESS =
  'SEND_MAIL_DEPOSIT_DETAIL_MONTH_SUCCESS';
export const SEND_MAIL_DEPOSIT_DETAIL_MONTH_FAILURE =
  'SEND_MAIL_DEPOSIT_DETAIL_MONTH_FAILURE';

export const SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_REQUEST =
  'SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_REQUEST';
export const SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_SUCCESS =
  'SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_SUCCESS';
export const SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_FAILURE =
  'SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_FAILURE';

export const getDeposits = params => dispatch => {
  dispatch({ type: GET_DEPOSITS_REQUEST });
  return getDepositsData(params)
    .then(response =>
      dispatch({
        type: GET_DEPOSITS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DEPOSITS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadDeposit = params => dispatch => {
  dispatch({ type: DOWNLOAD_DEPOSIT_REQUEST });
  return downloadDepositData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editDepositRegister = (shopId, params) => dispatch => {
  dispatch({ type: EDIT_DEPOSIT_REGISTER_REQUEST });
  return editDepositRegisterData(shopId, params)
    .then(response =>
      dispatch({
        type: EDIT_DEPOSIT_REGISTER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_DEPOSIT_REGISTER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getDepositCurrentMonthGroup = params => dispatch => {
  dispatch({ type: GET_DEPOSIT_CURRENT_MONTH_GROUP_REQUEST });
  return getDepositCurrentMonthGroupData(params)
    .then(response =>
      dispatch({
        type: GET_DEPOSIT_CURRENT_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DEPOSIT_CURRENT_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getDepositByMonthGroup = (month, params) => dispatch => {
  dispatch({ type: GET_DEPOSIT_BY_MONTH_GROUP_REQUEST });
  return getDepositByMonthGroupData(month, params)
    .then(response =>
      dispatch({
        type: GET_DEPOSIT_BY_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DEPOSIT_BY_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getDepositDetailCurrentMonthGroup = params => dispatch => {
  dispatch({ type: GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST });
  return getDepositDetailCurrentMonthGroupData(params)
    .then(response =>
      dispatch({
        type: GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getDepositDetailByMonthGroup = (month, params) => dispatch => {
  dispatch({ type: GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST });
  return getDepositDetailByMonthGroupData(month, params)
    .then(response =>
      dispatch({
        type: GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadDepositDetailCurrentMonth = params => dispatch => {
  dispatch({ type: DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_REQUEST });
  return downloadDepositDetailCurrentMonthData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_DETAIL_CURRENT_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadDepositDetailByMonth = (month, params) => dispatch => {
  dispatch({ type: DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_REQUEST });
  return downloadDepositDetailByMonthData(month, params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_DEPOSIT_DETAIL_BY_MONTH_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const sendMailDepositDetailMonth = month => dispatch => {
  dispatch({ type: SEND_MAIL_DEPOSIT_DETAIL_MONTH_REQUEST });
  return sendMailDepositDetailMonthData(month)
    .then(response =>
      dispatch({
        type: SEND_MAIL_DEPOSIT_DETAIL_MONTH_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SEND_MAIL_DEPOSIT_DETAIL_MONTH_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const sendMailDepositDetailByShopMonth = (month, shopId) => dispatch => {
  dispatch({ type: SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_REQUEST });
  return sendMailDepositDetailByShopMonthData(month, shopId)
    .then(response =>
      dispatch({
        type: SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SEND_MAIL_DEPOSIT_DETAIL_BY_SHOP_MONTH_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
